<template>
  <div id="data-edit-tab-info">

    <!-- Avatar Row -->
    <div class="vx-row">

      <div class="vx-col w-full">
        <div class="flex items-start flex-col sm:flex-row">
          <img :src="files[0]" class="mr-8 rounded h-24 w-24" />
          <!-- <vs-avatar :src="data_localavatar" size="80px" class="mr-4" /> -->
          <div>
            <!-- <p class="text-lg font-medium mb-2 mt-4 sm:mt-0">aaa</p> -->
            <input type="file" id="fileD" class="hidden" ref="update_avatar_input" @change="update_avatar" accept="image/*">

            <!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
            <!-- <vs-button type="border" class="mr-4 mb-4">Change Avatar</vs-button> -->
            <vs-button class="mr-4" @click="$refs.update_avatar_input.click()">Add Avatar</vs-button>

            <!-- <vs-button type="border" color="danger">Remove Avatar</vs-button> -->
          </div>
        </div>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2 mt-4">
        <!-- Col Header -->
        <div class="flex items-end">
          <feather-icon icon="InfoIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">Account Information</span>
        </div>    
      </div>
    </div>

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <div class="mt-4">
          <vs-input class="w-full mt-4" label="Name*" v-model="data_local.name" v-validate="'required'" name="name" type="text"/>
          <span class="text-danger text-sm"  v-show="errors.has('name')">{{ errors.first('name') }}</span>
        </div>

        <div class="mt-4">
          <label class="vs-input--label">Caliber Client Name*</label>
          <v-select :options="optionCaliberClient" :reduce="ClientName => ClientName.ClientID" label="ClientName" v-validate="'required'" v-model="data_local.caliber_client_id" name="caliber_client_id"/>
          <span class="text-danger text-sm"  v-show="errors.has('caliber_client_id')">{{ errors.first('caliber_client_id') }}</span>
        </div>

        <!-- <div class="mt-4">
          <label class="vs-input--label">Parent Org*</label>
          <v-select :options="optionParentOrg" :reduce="name => name.id" label="name" v-validate="'required'" v-model="data_local.pmc_id" name="pmc_id"/>
          <span class="text-danger text-sm"  v-show="errors.has('pmc_id')">{{ errors.first('pmc_id') }}</span>
        </div> -->
      </div>

      <div class="vx-col md:w-1/2 w-full">
        <div class="mt-4">
          <label class="vs-input--label">Property Type*</label>
          <v-select :options="optionPropertyType" :reduce="name => name.val" label="name" v-validate="'required'" v-model="data_local.property_type" name="property_type"/>
          <span class="text-danger text-sm"  v-show="errors.has('property_type')">{{ errors.first('property_type') }}</span>
        </div>

        <div class="mt-4">
          <vs-input class="w-full mt-4" label="Code*" v-model="data_local.code" type="text" v-validate="'required'" name="code" />
          <span class="text-danger text-sm"  v-show="errors.has('code')">{{ errors.first('code') }}</span>
        </div>

        <div class="mt-4">
          <vs-input class="w-full mt-4" label="Radius*" v-model="data_local.radius" type="text" v-validate="'required'" name="radius" />
          <span class="text-danger text-sm"  v-show="errors.has('radius')">{{ errors.first('radius') }}</span>
        </div>
      </div>
    </div>

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2 mt-4">
        <!-- Col Header -->
          <div class="flex items-end md:mt-0 mt-base">
            <feather-icon icon="MapPinIcon" class="mr-2" svgClasses="w-5 h-5" />
            <span class="leading-none font-medium">Office Details</span>
          </div>

        <!-- Col Content -->
        <div>
          <div class="vx-col w-full">
            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Address Line 1*" v-model="data_local.address_line_1" type="address_line_1" v-validate="'required'" name="address_line_1" />
              <span class="text-danger text-sm"  v-show="errors.has('address_line_1')">{{ errors.first('address_line_1') }}</span>
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Address Line 2" v-model="data_local.address_line_2" type="address_line_2" name="address_line_2" />
              <span class="text-danger text-sm"  v-show="errors.has('address_line_2')">{{ errors.first('address_line_2') }}</span>
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="State / Province" v-model="data_local.state" type="text" name="state" />
              <span class="text-danger text-sm"  v-show="errors.has('state')">{{ errors.first('state') }}</span>
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="City*" v-model="data_local.city" type="city" v-validate="'required'" name="city" />
              <span class="text-danger text-sm"  v-show="errors.has('city')">{{ errors.first('city') }}</span>
            </div>
            
            <div class="mt-4">
              <label class="vs-input--label">Country*</label>
              <v-select :options="optionCountry" :reduce="name => name.id" label="name" v-validate="'required'" v-model="data_local.country_id" name="country_id"/>
              <span class="text-danger text-sm"  v-show="errors.has('country_id')">{{ errors.first('country_id') }}</span>
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Postcode*" v-model="data_local.postal_code" type="text" v-validate="'required'" name="postal_code" />
              <span class="text-danger text-sm"  v-show="errors.has('postal_code')">{{ errors.first('postal_code') }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="vx-col w-full md:w-1/2 mt-4">
        <!-- Col Header -->
          <div class="flex items-end md:mt-0 mt-base">
            <feather-icon icon="MapPinIcon" class="mr-2" svgClasses="w-5 h-5" />
            <span class="leading-none font-medium">Billing Address</span>
          </div>

        <!-- Col Content -->
        <div>
          <div class="vx-col w-full">
            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Address Line 1*" v-model="data_local.BillingAddress1" type="text" v-validate="'required'" name="BillingAddress1" />
              <span class="text-danger text-sm"  v-show="errors.has('BillingAddress1')">{{ errors.first('BillingAddress1') }}</span>
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Address Line 2" v-model="data_local.BillingAddress2" type="text" name="BillingAddress2" />
              <span class="text-danger text-sm"  v-show="errors.has('BillingAddress2')">{{ errors.first('BillingAddress2') }}</span>
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="State / Province" v-model="data_local.BillingState" type="text" name="BillingState" />
              <span class="text-danger text-sm"  v-show="errors.has('BillingState')">{{ errors.first('BillingState') }}</span>
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="City*" v-model="data_local.BillingCity" type="text" v-validate="'required'" name="BillingCity" />
              <span class="text-danger text-sm"  v-show="errors.has('BillingCity')">{{ errors.first('BillingCity') }}</span>
            </div>
            
            <div class="mt-4">
              <label class="vs-input--label">Country*</label>
              <v-select :options="optionCountry" :reduce="name => name.id" label="name" v-validate="'required'" v-model="data_local.BillingCountry" name="BillingCountry"/>
              <span class="text-danger text-sm"  v-show="errors.has('BillingCountry')">{{ errors.first('BillingCountry') }}</span>
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Postcode*" v-model="data_local.BillingZip" type="text" v-validate="'required'" name="BillingZip" />
              <span class="text-danger text-sm"  v-show="errors.has('BillingZip')">{{ errors.first('BillingZip') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">Save Changes</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import axios from '../../../../axios'

export default {
  components: {
    vSelect
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      // uploading docs
      files: [],
      rawFiles: [],
      resDataLocal: [],
      resUp: [],

      //reading docs
      tableRead: [],
      files: [],

      token: localStorage.usertoken,

      optionSalutation: [],
      optionUserRole: [],
      optionCountry: [],
      optionPropertyType: [
        { id: 1, name: 'Single', val: 'single'},
        { id: 2, name: 'Multiple', val: 'multiple'},
        { id: 3, name: 'Community', val: 'community'}
      ],
      optionCaliberClient: [],
      optionParentOrg: [],      

      data_local: JSON.parse(JSON.stringify(this.data)),
      password: '',
      confirm_password: '',
      permissions: [{
        users: {
          'read': true,
          'write': false,
          'create': false,
          'delete': false
        },
        posts: {
          'read': true,
          'write': true,
          'create': true,
          'delete': true
        },
        comments: {
          'read': true,
          'write': false,
          'create': true,
          'delete': false
        }
      }],

      statusOptions: [
        { label: 'Active',  value: 'active' },
        { label: 'Blocked',  value: 'blocked' },
        { label: 'Deactivated',  value: 'deactivated' }
      ],
      roleOptions: [
        { label: 'Admin',  value: 'admin' },
        { label: 'User',  value: 'user' },
        { label: 'Staff',  value: 'staff' }
      ]
    }
  },
  computed: {
    status_local: {
      get () {
        return { label: this.capitalize(this.data_local.status),  value: this.data_local.status  }
      },
      set (obj) {
        this.data_local.status = obj.value
      }
    },
    role_local: {
      get () {
        return { label: this.capitalize(this.data_local.role),  value: this.data_local.role  }
      },
      set (obj) {
        this.data_local.role = obj.value
      }
    },
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    capitalize (str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },
    save_changes () {
      /* eslint-disable */

      this.data_local.password = this.confirm_password
      if (!this.validateForm) return

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */

      const editId = this.$route.params.editId
      new Promise(async(resolve, reject)  => {
        try {    
          await axios.post(`/property/save/${editId}`, {
              data: this.data_local,
              token: this.token
            })
            .then(res => {
              if(res['data'] != 'access_denied' && res['data'] != '') {

                //uploading docs
                if(res['data'] == 'success') {
                  //uploading docs
                  this.resDataLocal = res['data']['result']

                  this.$vs.notify({
                    color: 'success',
                    title: 'Data Saved',
                    text: 'The selected data was successfully Saved'
                  })

                  // this.$router.push({name:'app-property-view', params: {viewId: editId }})
                } else {
                  this.$vs.notify({
                    color: 'danger',
                    title: 'Saving Data',
                    text: 'Something went wrong'
                  })
                }

              } else {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Error loading',
                  text: 'Something went wrong'
                })
                this.$router.push({name:'app-property-view', params: {viewId: editId }})
              }

            })
            .catch(err => {
              this.$vs.notify({
                color: 'danger',
                title: 'Data Saving Error',
                text: 'The selected data was not saved'
              })
            }) 

            // uploading docs
            await axios.post(`/docs/table/save`, {
              rawFiles: this.rawFiles,
              token: this.token,
              id: editId,
              path: `docs/property/avatar/${editId}`,
              folderId: 26
            })

            this.$router.push({name:'app-property-view', params: {viewId: editId }})
        } catch(err) {
          reject(err.toString('utf8'));
        }      

      }) 
    },
    reset_data () {
      this.data_local = JSON.parse(JSON.stringify(this.data))
      this.$vs.notify({
        color: 'orange',
        title: 'Data Edit',
        text: 'The selected Data data was reset'
      })
    },
     // uploading docs
    _arrayBufferToBase64( buffer ) {
      var binary = '';
      var bytes = new Uint8Array( buffer );
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
          binary += String.fromCharCode( bytes[ i ] );
      }
      return window.btoa( binary );
    },
    // uploading docs
    async update_avatar () {
      this.$vs.loading()

      var formdata = new FormData();
      $.each($('#fileD')[0].files, function(i, file) {
        formdata.append('fileD_'+i, file);
      });
      formdata.append('token', this.token)

      this.resUp = await axios.post(`/docs/upload`,  
        formdata, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
        }
      )

      this.files = []
      for (const [key, value] of Object.entries(this.resUp.data.rawD)) {
        var imgB64 = this._arrayBufferToBase64( value.data.data )
        var imgAsc = imgB64.toString('ascii')
        this.files.push("data:image/png;base64, " + imgAsc)
      }

      if (this.resUp.data.uploadedD.length > 1) {
        for (const [key, value] of Object.entries(this.resUp.data.uploadedD)) {
          this.rawFiles.push(value)
        }
      } else {
        this.rawFiles[0] = this.resUp.data.uploadedD
      }

      setTimeout(() => {
        this.$vs.loading.close()
      }, 2000)
    },
    async loadData () {
      this.$vs.loading()

      const viewId = this.$route.params.editId
      var d = new Promise(async(resolve, reject)  => {
        try {    
            await axios.get(`/property/view/${viewId}`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {     
              if(res['data'] == 'access_denied' || res['data'] == '') {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Error loading',
                  text: 'Something went wrong'
                })
                // this.$router.push({name:'app-property-list'})
              } else {
                console.log('res d ', res['data'])
                resolve(res['data'][0])
              }

              // this.$vs.loading.close()
            })
            .catch(err => {
              this.data_not_found = true
              this.$vs.loading.close()
            })

            //reading docs
            this.tableRead = await axios.post(`/docs/table/read/`, {
              token: this.token,
              path: `docs/property/avatar/${viewId}`,
              document_folder_id: 26
            })

            //reading docs
            for (const [key, value] of Object.entries(this.tableRead.data.uploadedD)) {
              var imgB64 = this._arrayBufferToBase64( value.data.Body.data )
              var imgAsc = imgB64.toString('ascii')
              this.files.push("data:image/png;base64, " + imgAsc)
            }            
        } catch(err) {
          reject(err.toString('utf8'));
        }      

        // d.then((res) => {
        //   this.view_data = res[0]
        // })
        this.$vs.loading.close()
      })

      await d
    },
    loadUserRole () {
      var d = new Promise( async (resolve, reject)  => {
        try {    
          await axios.get(`/api/userRole/list`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {     
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }  
      })

      d.then((res) => {
        console.log('res user role ', res)
        this.optionUserRole = res
      })
    },
    loadSalutation () {
      var d = new Promise( async (resolve, reject)  => {
        try {    
          await axios.get(`/api/salutation/list`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {     
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }  
      })

      d.then((res) => {
        console.log('res salutation ', res)
        this.optionSalutation = res
      })
    },
    loadCountry () {
      var d = new Promise( async (resolve, reject)  => {
        try {    
          await axios.get(`/api/country/list`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {     
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }  
      })

      d.then((res) => {
        console.log('res country ', res)
        this.optionCountry = res
      })
    },
    loadUserRole () {
      var d = new Promise( async (resolve, reject)  => {
        try {    
          await axios.get(`/api/userRole/list`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {     
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }  
      })

      d.then((res) => {
        console.log('res user role ', res)
        this.optionUserRole = res
      })
    },
    async loadCaliberClient () {
      var d = await axios.get('/caliber/api', {
          headers: { 
            'Authorization': this.token,
            'caliber-url': 'api/v2/clientlist'
            // api/v2/clientlist
            // clientlist        
            // client/27/clientcontacts
            // client/27/contacts/all
            // client/27/units
            // client/27/vendors
            // client/27/invoices
            // client/27/billingrecords/all
            // client/27/transactionaccounts
          },
        })

        this.optionCaliberClient = d['data']
        console.log('this.optionCaliberClient ', this.optionCaliberClient)
    },
    async loadParentOrg () {
      var d = await axios.get('/portfolio/list', {
          headers: { 
            'Authorization': this.token,
          },
        })

        this.optionParentOrg = d['data']
        console.log('this.optionParentOrg  ', this.optionParentOrg)
    }
  },
  created () {
    this.loadUserRole()
    this.data_local.password = null
    this.loadData()
    this.loadSalutation()
    this.loadCountry()
    this.loadUserRole()
    this.loadCaliberClient()
    this.loadParentOrg()
  }
}
</script>
